import { useState } from "react";
import { useNavigate } from "react-router";
import { api } from "@/lib/api";
import { useUserId } from "@/hooks/useUserId";

export function CreateRoom() {
	const navigate = useNavigate();
	const userId = useUserId();
	const [roomName, setRoomName] = useState("");
	const [isCreatingRoom, setIsCreatingRoom] = useState(false);
	const [createRoomError, setCreateRoomError] = useState<string | null>(null);

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		if (isCreatingRoom) return;

		setCreateRoomError(null);
		setIsCreatingRoom(true);

		const trimmedName = roomName.trim();
		const payload = trimmedName.length > 0 ? { userId, name: trimmedName } : { userId };
		const { data, error } = await api.chat.new.post(payload);
		setIsCreatingRoom(false);

		if (error) {
			const status = (error as any)?.status;
			const value = (error as any)?.value;
			if (status === 409) {
				setCreateRoomError("Room name already exists. Please choose another.");
			} else if (status === 429) {
				setCreateRoomError("Too many room creations. Please wait and try again.");
			} else if (status === 400 && value === "Please use a proper title!") {
				setCreateRoomError("Please use a proper title!");
			} else {
				setCreateRoomError("Failed to create room. Please try again.");
			}
			return;
		}

		if (!data) {
			setCreateRoomError("Failed to create room. Please try again.");
			return;
		}

		navigate(`/room/${data.id}`);
	}

	return (
		<div className="relative h-dvh w-full" style={{ background: "#81818130" }}>
			<div className="absolute inset-0 pointer-events-none z-0">
				<img
					src="/images/Home2.png"
					alt=""
					style={{ opacity: 0.5, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
				/>
			</div>

			<div className="absolute inset-0 z-10 flex items-center justify-center p-4 min-[1000px]:p-6">
				<div className="w-full max-w-137.5 border border-white bg-black">
					<div className="h-16 px-7 border-b border-white bg-[#1F1F1F] text-white flex items-center gap-3">
						<button
							onClick={() => navigate("/")}
							className="group cursor-pointer hover:text-white transition-colors text-sm tracking-widest flex items-center gap-2"
						>
							<img src="/images/left-arrow.svg" alt="back" className="w-4 h-4" />
						</button>
						<h1 className="uppercase font-tomorrow-bold leading-[130%] tracking-[20%]">Name The Room</h1>
					</div>

					<form
						onSubmit={handleSubmit}
						className="min-h-65 px-6 min-[1000px]:px-10 py-10 min-[1000px]:py-16 flex items-center justify-center"
					>
						<div className="w-full max-w-92.5 flex flex-col gap-3 min-[1000px]:gap-5">
							<div className="w-full flex items-center gap-3 min-[1000px]:gap-5 sm:flex-row flex-col">
								<input
									type="text"
									value={roomName}
									onChange={(e) => setRoomName(e.target.value)}
									placeholder="Name..."
									className="flex-1 min-[1000px]:h-10 px-5 py-2 bg-[#1F1F1F] border border-white/60 outline-none text-white placeholder:text-white/60 font-tomorrow-light tracking-[20%]"
								/>
								<button
									type="submit"
									disabled={isCreatingRoom}
									className="h-10 px-7 bg-white text-black border border-white leading-6 tracking-[20%] font-tomorrow-light cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
								>
									{isCreatingRoom ? "Creating..." : "Create"}
								</button>
							</div>
							{createRoomError && <p className="text-[11px] tracking-wide text-[#f5b942]">{createRoomError}</p>}
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}
